import _ from "lodash";

export const sanitizeSubSchemePayload = (sub_schemes = []) => {
    if (!sub_schemes.length) return [];

    return sub_schemes.map((sub_scheme) => {
        const sub_scheme_data = _.pick(sub_scheme, [
            "id",
            "scheme_id",
            "sub_scheme_type_id",
            "first_reduction",
            "sub_scheme_details",
        ]);

        for (const row of sub_scheme_data.sub_scheme_details) {
            row.min_value = row.min_value ? Number(row.min_value) : null;
            row.max_value = row.max_value ? Number(row.max_value) : null;
            row.incentive_percent = row.incentive_percent ? Number(row.incentive_percent) : null;
        }

        return sub_scheme_data;
    });
};
